import { Component, OnInit, OnDestroy } from '@angular/core';
import { CatalogueService } from 'app/components/catalogue/catalogue.service';
import { DomService } from 'app/components/dom/dom.service';
import { ActivatedRoute, Router } from '@angular/router';
import { ModalYesNoComponent } from "../../components/modal-yes-no/modal-yes-no.component";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import * as XLSX from 'xlsx';

@Component({
  selector: 'app-exhibitor-backoffice-exhibitors-import',
  templateUrl: './exhibitor-backoffice-exhibitors-import.component.html',
  styleUrls: ['./exhibitor-backoffice-exhibitors-import.component.css']
})
export class ExhibitorBackofficeExhibitorsImportComponent implements OnInit, OnDestroy {

  loader: any = { count: 0 };
  alertType: string = '';
  alertMessage: string = '';

  eventName: string | null = '';
  buttonLink: string = '';
  selectedFile: File | null = null;
  isValidFile: boolean = false;

  constructor(
    public catalogueService: CatalogueService,
    private domService: DomService,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private modalService: NgbModal
  ) {
    this.eventName = this.activatedRoute.snapshot.paramMap.get('event') || null;
    this.buttonLink = '/' + this.eventName + '/exhibitor-backoffice/exhibitors';
  }

  ngOnInit() {
    this.domService.addClassToBody('bg-gray');
  }

  ngOnDestroy() {
    this.domService.removeClassFromBody('bg-gray');
  }

  onFileChange(event: any) {
    const file = event.target.files[0];
    if (file) {
      this.selectedFile = file;
      const extension = file.name.split('.').pop().toLowerCase();
      this.isValidFile = extension === 'csv' || extension === 'xlsx';
    } else {
      this.selectedFile = null;
      this.isValidFile = false;
    }
  }

  cancel() {
    this.router.navigate([this.buttonLink]);
  }

  downloadTemplate() {
    const headers = [['ID_SAP', 'EMAIL', 'BRAND', 'WEB', 'COUNTRY_ID', 'CATEGORY_IDS', 'URL_IMAGE', 'ID_EXP', 'STAND', 'SAP_ORDER_ID', 'FORGOT_PASSWORD']];
    const wb = XLSX.utils.book_new();
    const ws = XLSX.utils.aoa_to_sheet(headers);
    XLSX.utils.book_append_sheet(wb, ws, 'Template');
    XLSX.writeFile(wb, 'exhibitor_upload_template.xlsx');
  }

  uploadBtn() {
    if (!this.isValidFile || !this.selectedFile) return;

    const modalRef = this.modalService.open(ModalYesNoComponent);
    modalRef.componentInstance.question = 'EXHIBITOR_BACKOFFICE_EXHIBITORS_IMPORT.CONFIRM_QUESTION';

    modalRef.result.then((option) => {
      if (option === 'yes') {
        this.uploadExhibitors();
      }
    });
  }

  uploadExhibitors() {
    this.loader.count++;
    this.alertType = '';
    this.alertMessage = '';

    const dataIn = {
      catalogueId: this.catalogueService.getProperty('id')
    };

    this.catalogueService.uploadExhibitors(this.selectedFile, dataIn)
      .subscribe({
        next: (data: any) => {
          this.loader.count--;
          this.alertType = 'success';
          this.alertMessage = 'EXHIBITOR_BACKOFFICE_EXHIBITORS_IMPORT.SUCCESS';
          setTimeout(() => {
            this.router.navigate([this.buttonLink]);
          }, 2000);
        },
        error: (error: any) => {
          this.loader.count--;
          this.alertType = 'error';
          this.alertMessage = error.error?.message || 'EXHIBITOR_BACKOFFICE_EXHIBITORS_IMPORT.ERROR';
        }
      });
  }
}
